"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.permissionsData = exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _classnames = _interopRequireDefault(require("classnames"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cccisdApollo = require("cccisd-apollo");
var _cccisdGraphqlTable = _interopRequireDefault(require("cccisd-graphql-table"));
var _cccisdHiddenBlock = _interopRequireDefault(require("cccisd-hidden-block"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _Header = _interopRequireDefault(require("../../components/Header"));
var _LackingPermissions = _interopRequireDefault(require("../../components/LackingPermissions"));
var _questPermissionsByArea = _interopRequireDefault(require("../../helpers/questPermissionsByArea.js"));
var _admin = require("../../selectors/admin.js");
var _AddPawnRule = _interopRequireDefault(require("./AddPawnRule"));
var _pawnsWithPermissions = _interopRequireDefault(require("./pawnsWithPermissions.graphql"));
var _pawnsWithPermissionsAsSuper = _interopRequireDefault(require("./pawnsWithPermissionsAsSuper.graphql"));
var _permissionIds = _interopRequireDefault(require("./permissionIds.graphql"));
var _rolePermissions = _interopRequireDefault(require("./rolePermissions.graphql"));
var _tableRenderPawnPermissionEdit = _interopRequireDefault(require("./tableRenderPawnPermissionEdit.js"));
var _tableRenderRolePermissionEdit = _interopRequireDefault(require("./tableRenderRolePermissionEdit.js"));
var _style = _interopRequireDefault(require("./style.css"));
var _plus = _interopRequireDefault(require("cccisd-icons/plus2"));
var _checkmark = _interopRequireDefault(require("cccisd-icons/checkmark"));
var _palette = _interopRequireDefault(require("cccisd-icons/palette"));
var _paperplane = _interopRequireDefault(require("cccisd-icons/paperplane"));
var _meterMedium = _interopRequireDefault(require("cccisd-icons/meter-medium"));
var _listNumbered = _interopRequireDefault(require("cccisd-icons/list-numbered"));
var _fileSpreadsheet = _interopRequireDefault(require("cccisd-icons/file-spreadsheet2"));
var _userLock = _interopRequireDefault(require("cccisd-icons/user-lock"));
var _cog = _interopRequireDefault(require("cccisd-icons/cog2"));
var _envelop = _interopRequireDefault(require("cccisd-icons/envelop3"));
var _copy = _interopRequireDefault(require("cccisd-icons/copy3"));
var _userCheck = _interopRequireDefault(require("cccisd-icons/user-check"));
var _stackPlus = _interopRequireDefault(require("cccisd-icons/stack-plus"));
var _pencil = _interopRequireDefault(require("cccisd-icons/pencil"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var AppDefs = window.cccisd.appDefs;
var Fortress = window.cccisd.fortress;

/*
 * permissionsData is used by many other files in this page. The order of the
 * entries is important.
 */
var permissionsData = exports.permissionsData = [{
  alias: 'design',
  permission: 'quest.design',
  labelIcon: _palette["default"],
  tooltip: 'Design tab access',
  topHeader: 'Tabs',
  topHeaderSpan: 8,
  formLabel: 'Design',
  toggleFieldAliasesWhenSet: ['copySurveys']
}, {
  alias: 'deploy',
  permission: 'quest.deploy',
  labelIcon: _paperplane["default"],
  tooltip: 'Deploy tab access',
  formLabel: 'Deploy',
  toggleFieldAliasesWhenSet: ['messaging']
}, {
  alias: 'status',
  permission: 'quest.status',
  labelIcon: _meterMedium["default"],
  tooltip: 'Progress tab access',
  formLabel: 'Progress'
}, {
  alias: 'code',
  permission: 'quest.code',
  labelIcon: _listNumbered["default"],
  tooltip: 'Code tab access',
  formLabel: 'Code'
}, {
  alias: 'viewData',
  permission: 'quest.view_data',
  labelIcon: _fileSpreadsheet["default"],
  tooltip: 'Data tab access',
  formLabel: 'Data'
}, {
  alias: 'permissions',
  permission: 'quest.permissions',
  labelIcon: _userLock["default"],
  tooltip: 'Permissions tab access',
  formLabel: 'Permissions'
}, {
  alias: 'admin',
  permission: 'quest.admin',
  labelIcon: _cog["default"],
  tooltip: 'Full control over this Quest Project, including Manage Projects tab access and ability to set permissions',
  formLabel: 'Full control over this Quest Project',
  toggleFieldAliasesWhenSet: ['design', 'deploy', 'status', 'code', 'viewData', 'messaging', 'copySurveys', 'tablesEdit', 'modifyData']
}, {
  alias: 'copySurveys',
  permission: 'quest.copy_surveys',
  labelIcon: _copy["default"],
  tooltip: 'Copy surveys from this project into other projects',
  topHeader: 'Permissions',
  topHeaderSpan: 5
}, {
  alias: 'messaging',
  permission: 'quest.messaging',
  labelIcon: _envelop["default"],
  tooltip: 'Access exported Messaging area'
}, {
  alias: 'viewIdentifiableData',
  permission: 'quest.view_identifiable_data',
  labelIcon: _userCheck["default"],
  tooltip: 'View identifiable data'
}, {
  alias: 'tablesEdit',
  permission: 'quest.tables_edit',
  labelIcon: _stackPlus["default"],
  tooltip: 'Modify Queries'
}, {
  alias: 'modifyData',
  permission: 'quest.modify_data',
  labelIcon: _pencil["default"],
  tooltip: 'Modify/delete data'
}];

// the inverse relationship of toggleFieldAliasesWhenSet for faster lookup
var mapOfWhichPermsAreValid = {};
permissionsData.forEach(function (perm) {
  if (!mapOfWhichPermsAreValid[perm.alias]) {
    mapOfWhichPermsAreValid[perm.alias] = {};
  }
  mapOfWhichPermsAreValid[perm.alias][perm.alias] = true;
  (perm.toggleFieldAliasesWhenSet || []).forEach(function (subPermAlias) {
    if (!mapOfWhichPermsAreValid[subPermAlias]) {
      mapOfWhichPermsAreValid[subPermAlias] = {};
    }
    mapOfWhichPermsAreValid[subPermAlias][perm.alias] = true;
  });
});
var Permissions = function Permissions() {
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = (0, _react.useState)({}),
    _useState4 = _slicedToArray(_useState3, 2),
    graphqlPermissionVariables = _useState4[0],
    setGraphqlPermissionVariables = _useState4[1];
  var project = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin.getCurrentProject)(state.assignment.admin);
  }) || {};
  var canManage = Fortress.hasAnyAccess(_questPermissionsByArea["default"].manage.permissions, project.groupId);

  /* /////////////////////////////////////////////////////////////////////////
  // LIFECYCLE //////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  (0, _react.useEffect)(function () {
    function loadPermissionIds() {
      return _loadPermissionIds.apply(this, arguments);
    }
    function _loadPermissionIds() {
      _loadPermissionIds = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var response, responsePermissionList, updatedVariables;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _cccisdApollo.client.query({
                query: _permissionIds["default"],
                fetchPolicy: 'network-only'
              });
            case 1:
              response = _context.v;
              responsePermissionList = (0, _get2["default"])(response, 'data.roles.permissionList');
              updatedVariables = {};
              permissionsData.forEach(function (p) {
                var responsePermission = responsePermissionList.find(function (rp) {
                  return rp.permission === p.permission;
                });
                updatedVariables["".concat(p.alias, "PermId")] = responsePermission ? responsePermission.permissionId : 0;
              });
              setGraphqlPermissionVariables(updatedVariables);
              setLoading(false);
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return _loadPermissionIds.apply(this, arguments);
    }
    loadPermissionIds();
  }, []);

  /* /////////////////////////////////////////////////////////////////////////
  // ADD RULE–RELATED ///////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  var addPawnRuleButton = function addPawnRuleButton(loadData) {
    return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
      trigger: /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-primary"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].iconSpace
      }, /*#__PURE__*/_react["default"].createElement(_plus["default"], null)), "Add People"),
      render: function render(_ref) {
        var closeModal = _ref.closeModal;
        return /*#__PURE__*/_react["default"].createElement(_AddPawnRule["default"], {
          closeModal: closeModal,
          loadData: loadData
        });
      },
      size: "large",
      title: "Add People to ".concat(project.label)
    });
  };

  /* /////////////////////////////////////////////////////////////////////////
  // PAWN TABLE-RELATED /////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  var appdefRoles = AppDefs.pawn.roles || [];
  var roleFilterOptions = appdefRoles.map(function (p) {
    return {
      label: p.label,
      value: p.handle
    };
  });
  var actionsColumn = [{
    name: 'actions',
    label: 'Actions',
    render: _tableRenderPawnPermissionEdit["default"]
  }];
  var baseColumns = [{
    name: 'user.username',
    label: 'Username',
    sort: true,
    filter: true
  }, {
    name: 'user.firstName',
    label: 'First Name',
    sort: true,
    filter: true
  }, {
    name: 'user.lastName',
    label: 'Last Name',
    sort: true,
    filter: true
  }, {
    name: 'parentGroup.anyGroup.group.label',
    label: 'Group',
    sort: true,
    filter: true
  }, {
    name: 'pawn.role',
    label: 'Role',
    sort: true,
    filter: true,
    filterSettings: {
      type: 'selectbox',
      options: roleFilterOptions
    },
    render: function render(_ref2) {
      var value = _ref2.value;
      var roleDef = appdefRoles.find(function (r) {
        return r.handle === value;
      });
      return roleDef ? roleDef.label : value;
    }
  }];
  var permissionColumns = permissionsData.map(function (p) {
    var LabelIcon = p.labelIcon;
    var label = /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: p.tooltip
    }, /*#__PURE__*/_react["default"].createElement(LabelIcon, null));
    return {
      name: "".concat(p.alias, "Perm"),
      label: label,
      className: 'text-center',
      sort: false,
      topHeader: p.topHeader || null,
      topHeaderSpan: p.topHeaderSpan || null,
      filter: true,
      filterSettings: {
        type: 'selectbox',
        options: [{
          label: 'Y',
          value: '1'
        }, {
          label: 'N',
          value: '0'
        }]
      },
      render: function render(_ref3) {
        var row = _ref3.row;
        var hasPermission = false;
        var isInverse = false;
        Object.keys(mapOfWhichPermsAreValid[p.alias]).some(function (otherPermAlias) {
          if ((0, _get2["default"])(row, "".concat(otherPermAlias, "Perm")) === '1') {
            hasPermission = true;

            // "system-granted" if there's no targetId or if it's a role-based permission
            var isRolePerm = (0, _get2["default"])(row, "".concat(otherPermAlias, "RolePerm"), '0') === '1';
            var isGlobalPerm = !(0, _get2["default"])(row, "".concat(otherPermAlias, "PawnPerm.targetId"));
            isInverse = isRolePerm || isGlobalPerm;
          }
          return hasPermission && isInverse; // stop looping
        });
        return hasPermission ? /*#__PURE__*/_react["default"].createElement("span", {
          className: isInverse ? _style["default"].showInverse : null
        }, /*#__PURE__*/_react["default"].createElement(_checkmark["default"], null)) : null;
      }
    };
  });
  var pawnTableColumns = [].concat(baseColumns, _toConsumableArray(permissionColumns));
  if (canManage) {
    pawnTableColumns = [].concat(actionsColumn, _toConsumableArray(pawnTableColumns));
  }

  /* /////////////////////////////////////////////////////////////////////////
  // ROLE TABLE-RELATED /////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  var roleBaseColumns = [{
    name: 'label',
    label: 'Role',
    sort: false,
    filter: false
  }];
  var rolePermissionColumns = permissionsData.map(function (p) {
    var LabelIcon = p.labelIcon;
    var label = /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: p.tooltip
    }, /*#__PURE__*/_react["default"].createElement(LabelIcon, null));
    return {
      name: "".concat(p.alias, "Perm"),
      label: label,
      className: 'text-center',
      sort: false,
      topHeader: p.topHeader || null,
      topHeaderSpan: p.topHeaderSpan || null,
      filter: true,
      filterSettings: {
        type: 'selectbox',
        options: [{
          label: 'Y',
          value: '1'
        }, {
          label: 'N',
          value: '0'
        }]
      },
      render: function render(_ref4) {
        var row = _ref4.row;
        var rolePerm = !!(0, _get2["default"])(row, "".concat(p.alias, "RolePerm.permission"));
        var roleTarget = !!(0, _get2["default"])(row, "".concat(p.alias, "RolePerm.targetId"));
        return rolePerm ? /*#__PURE__*/_react["default"].createElement("span", {
          className: !roleTarget ? _style["default"].showInverse : null
        }, /*#__PURE__*/_react["default"].createElement(_checkmark["default"], null)) : null;
      }
    };
  });
  var roleTableColumns = function roleTableColumns(outerLoadData) {
    var roleActionsColumn = {
      name: 'actions',
      label: 'Actions',
      render: (0, _tableRenderRolePermissionEdit["default"])({
        outerLoadData: outerLoadData,
        project: project
      })
    };
    return [roleActionsColumn].concat(roleBaseColumns, _toConsumableArray(rolePermissionColumns));
  };
  var includeRoles = appdefRoles.filter(function (r) {
    return r.isFortressUser && !['respondent'].includes(r.handle);
  }).map(function (r) {
    return r.handle;
  });

  /* /////////////////////////////////////////////////////////////////////////
  // RENDER-RELATED /////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  var legend = /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('float-end', _style["default"].legend)
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _style["default"].checkmarkPadding
  }, /*#__PURE__*/_react["default"].createElement(_checkmark["default"], null)), ": individually granted permission", /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("span", {
    className: _style["default"].showInverse
  }, /*#__PURE__*/_react["default"].createElement(_checkmark["default"], null)), ": system-granted permission");
  var renderMainTable = function renderMainTable(_ref5) {
    var loadData = _ref5.loadData,
      renderDefault = _ref5.renderDefault;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].headerBlock
    }, /*#__PURE__*/_react["default"].createElement("h2", {
      style: {
        display: 'inline-block'
      }
    }, "People"), canManage && addPawnRuleButton(loadData)), renderDefault(), legend, canManage && /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].bottomTableWrapper
    }, /*#__PURE__*/_react["default"].createElement(_cccisdHiddenBlock["default"], {
      title: "Advanced"
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h2", {
      style: {
        display: 'inline-block'
      }
    }, "Roles")), /*#__PURE__*/_react["default"].createElement(_cccisdGraphqlTable["default"], {
      key: "permissions",
      columns: roleTableColumns(loadData),
      query: _rolePermissions["default"],
      rowKey: "handle",
      isStickyHeader: true,
      graphqlVariables: _objectSpread({
        includeRoles: includeRoles,
        projectId: project.groupId,
        permissions: permissionsData.map(function (p) {
          return p.permission;
        })
      }, graphqlPermissionVariables)
    }), legend)));
  };

  /* /////////////////////////////////////////////////////////////////////////
  // RENDER /////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  if (!project.groupId || !Fortress.hasAnyAccess(_questPermissionsByArea["default"].permissions.permissions, project.groupId)) {
    return /*#__PURE__*/_react["default"].createElement(_LackingPermissions["default"], null);
  }
  if (loading) {
    return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
      loading: true
    });
  }
  var isSuperUser = Fortress && Fortress.isSuperUser();
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Header["default"], {
    showProjectDropdown: true,
    showQuestCount: false
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].tableWrapper
  }, /*#__PURE__*/_react["default"].createElement(_cccisdGraphqlTable["default"], {
    key: "permissions",
    columns: pawnTableColumns,
    query: isSuperUser ? _pawnsWithPermissionsAsSuper["default"] : _pawnsWithPermissions["default"],
    rowKey: "pawn.pawnId",
    isStickyHeader: true,
    graphqlVariables: _objectSpread({
      projectId: project.groupId,
      permissions: permissionsData.map(function (p) {
        return p.permission;
      })
    }, graphqlPermissionVariables),
    render: renderMainTable
  })));
};
var _default = exports["default"] = Permissions;